import { observable, action, computed } from "mobx"
import { get_scryfall, get_imgur } from "../utils/api";
import { shuffle, filterCards } from "../utils/utility";

let officialCards = {};
let imgurCards = {};

export default class CardStore {
  @observable cards = [{ image: '', official: '' }];
  @observable curIndex = 0;
  //TODO - refactor. 0 = official, 1 = imgur, 2 = combined
  @observable curSource = -1;
  @observable sourceName = 'Official';
  @observable isLoading = true;
  

  @action updateCards(cards) {
    this.cards = cards;
  }

  @action updateCurIndex(index) {
    this.curIndex = index;
  }

  @action updateIsLoading(load) {
    this.isLoading = load;
  }

  @action updateSourceName(name) {
    this.sourceName = name;
  }

  @computed get isEmpty() {
    return Object.keys(this.cards).length === 0;
  }

  @computed get cardImgUrl() {
    return this.cards[this.curIndex].image;
  }

  @computed get isOfficial() {
    return this.cards[this.curIndex].official;
  }

  nextPlane = () => {
    if(this.curIndex + 1 >= this.cards.length) {
      this.cards = shuffle(this.cards);
      this.updateCurIndex(0);
    } else {
      this.updateCurIndex(this.curIndex + 1);
    }
  }

  prevPlane = () => {
    if((this.curIndex - 1) >= 0) {
      this.updateCurIndex(this.curIndex - 1);
    }
  }

  fetchCardsFromScryfall = async () => {
    let deck;
    if(Object.keys(officialCards).length === 0) {
      deck = await get_scryfall();
      deck = deck.map(card => ({ image: card.image_uris.normal, official: true }));
      officialCards = deck;
    } else {
      deck = officialCards
    }
    deck = shuffle(deck);
    return deck;
  }

  fetchCardsFromImgur = async () => {
    let deck;
    if(Object.keys(imgurCards).length === 0) {
      const toRemove = [2,3,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,32,34,36,51,55,62,68,69];
      deck = await get_imgur();
      deck = filterCards(deck, toRemove);
      deck = deck.map(card => ({ image: card.link, official: false }));
      imgurCards = deck;
    } else {
      deck = imgurCards;
    }
    deck = shuffle(deck);
    return deck;
  }

  fetchAll = async () => {
    let deck = [ ...await this.fetchCardsFromScryfall(), ...await this.fetchCardsFromImgur() ];
    deck = shuffle(deck);
    return deck;
  }

  async updateCardSource() {
    this.updateIsLoading(true);
    let deck;
    this.curSource === 2 ? this.curSource = 0 : this.curSource++
    switch(this.curSource)  {
      case 0:
        deck = await this.fetchCardsFromScryfall();
        this.updateSourceName('Official');
        break;
      case 1:
        deck = await this.fetchCardsFromImgur();
        this.updateSourceName('Imgur');
        break;
      case 2:
        deck = await this.fetchAll();
        this.updateSourceName('Combined');
        break;
      default:
        deck = await this.fetchCardsFromScryfall();
        await this.fetchCardsFromScryfall();
        this.updateSourceName('Official')
    }
    this.updateCards(deck);
    this.updateIsLoading(false);
  }
}
